import React, { useCallback } from "react";
import { useQuery } from "@apollo/client/react";

import { GROUPED_ASSET_QUERY } from "../constants/graphql/queries";
import useMutation from "../hooks/useMutation";
import {
  DELETE_GROUPED_ASSET_MEMBER_MUTATION,
} from "../constants/graphql/mutations";
import useNotification from "../hooks/notification";

const GroupedAssetContext = React.createContext(null);

export const GroupedAssetProvider = ({ children, id }) => {
  const { notifySuccess } = useNotification();
  const { refetch, loading, data: { asset = {} } = {} } = useQuery(GROUPED_ASSET_QUERY, {
    variables: { id },
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
  });

  const [remove] = useMutation(DELETE_GROUPED_ASSET_MEMBER_MUTATION, {
    refetchQueries: [{ query: GROUPED_ASSET_QUERY, variables: { id } }],
  });

  const removeGroupedAssetMember = useCallback(
    id => {
      return remove({
        variables: { id },
        onSuccess() {
          notifySuccess("Reference item was removed");
        },
      });
    },
    [notifySuccess, remove]
  );

  return (
    <GroupedAssetContext.Provider
      value={{ groupedAsset: asset, loading, refetch, removeGroupedAssetMember }}
    >
      {children}
    </GroupedAssetContext.Provider>
  );
};

export const useGroupedAsset = () => React.useContext(GroupedAssetContext);

